function createAttachmentElement(tagName, className = '', text = null) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== null) element.textContent = text;
  return element;
}

function isSafeAttachmentPreviewUrl(value) {
  const source = String(value ?? '');
  if (/^data:image\/(?:png|jpe?g|gif|webp);base64,/i.test(source)) return true;
  try {
    const url = new URL(source, window.location.origin);
    return ['http:', 'https:'].includes(url.protocol);
  } catch {
    return false;
  }
}

function createUploadState(item) {
  const state = createAttachmentElement('div', `aichat-upload-state${item.status === 'error' ? ' aichat-upload-state--error' : ''}`);
  state.setAttribute('role', 'status');
  const detail = createAttachmentElement('span', '', item.name ?? '');
  detail.append(
    document.createElement('br'),
    createAttachmentElement('small', '', item.status === 'error' ? `上传失败：${item.error ?? ''}` : '正在上传…'),
  );
  state.append(detail);
  return state;
}

function createAttachmentThumb(attachment, index) {
  const thumb = createAttachmentElement('div', 'aichat-attachment-thumb');
  const image = document.createElement('img');
  image.alt = attachment.originalName ?? '';
  if (isSafeAttachmentPreviewUrl(attachment.dataUrl)) image.src = attachment.dataUrl;
  else image.hidden = true;
  const remove = createAttachmentElement('button', 'aichat-attachment-remove', '×');
  remove.type = 'button';
  remove.dataset.index = String(index);
  remove.title = '移除';
  thumb.append(image, remove, createAttachmentElement('span', 'aichat-attachment-name', attachment.originalName ?? ''));
  return thumb;
}

export function renderAttachmentPreview(root, { pendingAttachments = [], uploadingFiles = [] } = {}) {
  if (!root) return false;
  if (!pendingAttachments.length && !uploadingFiles.length) {
    root.replaceChildren();
    return false;
  }
  root.replaceChildren(
    ...uploadingFiles.map(createUploadState),
    ...pendingAttachments.map(createAttachmentThumb),
  );
  return true;
}
